import { render, staticRenderFns } from "./editPlat.vue?vue&type=template&id=70af3afd&"
import script from "./editPlat.vue?vue&type=script&lang=js&"
export * from "./editPlat.vue?vue&type=script&lang=js&"
import style0 from "./editPlat.vue?vue&type=style&index=0&id=70af3afd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports